import React from 'react'
import GradientText from './Animations/GradientText'
import BlurText from './Animations/BlurText'
import ShinyText from './Animations/ShinyText'
import AnimatedContent from './Animations/AnimatedContent'

export default function Hero() {
  return <div className='header md:h-[68vw] md:pt-[15vw] pt-[35vw] px-[5vw] md:pb-0 pb-14 relative'>
    <img src="/images/star.png" alt="" className='md:w-[2vw] w-[8vw]  absolute md:top-[15vw] top-[22vw] left-[20vw]  blink_animation' />
    <img src="/images/star.png" alt="" className='md:w-[2vw] w-[8vw]  absolute bottom-[13vw] left-[15vw] blink_animation' />
    <img src="/images/star.png" alt="" className='md:w-[2vw] w-[8vw]  absolute bottom-[18vw] md:right-[46vw] right-[6vw] blink_animation' />
    <div className='grid md:grid-cols-2 gap-10'>
      <div className='flex flex-col justify-center items-start'>
        <GradientText
          colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
          animationSpeed={3}
          showBorder={false}
          className="font-medium text-lg mb-2  "
        >
          AI Agent of Griffain Engine
        </GradientText>
        <BlurText
          text="Agent DORA Onchain Agnostic AI Agent of Griffain Engine"
          delay={150}
          animateBy="words"
          direction="top"
          className="lg:text-6xl md:text-4xl text-3xl font-bold mb-8"
        />

        <AnimatedContent
          distance={150}
          direction="horizontal"
          reverse={false}
          config={{ tension: 80, friction: 20 }}
          initialOpacity={0.2}
          animateOpacity
          scale={1.1}
          threshold={0.2}
        >
          <ShinyText text="fondly called as the Google of Griffain, for its effective On-Chain agnostic search and trading. "
            disabled={false} speed={3} className='custom-class' />
        </AnimatedContent>


        <div className='flex items-center md:gap-5 gap-3 mt-5'>

          <AnimatedContent
            distance={150}
            direction="vertical"
            reverse={false}
            config={{ tension: 80, friction: 20 }}
            initialOpacity={0.2}
            animateOpacity
            scale={1.1}
            threshold={0.2}
          >
            <a href="">
              <button class="btn2 md:px-10 px-6 md:py-4 py-3 md:text-base text-sm text-nowrap rounded-full">Join Community </button>
            </a>
          </AnimatedContent>
          <AnimatedContent
            distance={150}
            direction="vertical"
            reverse={false}
            config={{ tension: 80, friction: 20 }}
            initialOpacity={0.2}
            animateOpacity
            scale={1.1}
            threshold={0.4}
          >
            <a href="">
              <button class="btn1 md:px-10 px-6 md:py-4 py-3 md:text-base text-sm text-nowrap rounded-full">Learn More</button>
            </a>
          </AnimatedContent>


        </div>

      </div>
      <div>
        <img src="/images/glop.png" alt="" className='w-[90%] mx-auto rotate_animation' />
      </div>
    </div>
  </div>
}
